/* eslint-disable @typescript-eslint/no-unused-vars */

import { updateComponent } from '../../../../app/package-designer/store/component.actions';

xplenty.directive('limitEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./limit-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        'ngrxStoreService',
        function ($scope, ngrxStoreService) {
          $scope.sortValidity = true;
          $scope.groupByValidity = true;

          $scope.onPartitioningChange = ({ partitioning }) => {
            const component = { partitioning };
            if (partitioning === 'all') {
              $scope.component.partitioned_fields = [];
              component.partitioned_fields = [];
            }
            ngrxStoreService.dispatch(updateComponent({ component }));
          };

          $scope.onOrderChange = ({ order }) => {
            const component = { order };
            if (order === 'no_sort') {
              component.ordered_fields = [];
            }
            ngrxStoreService.dispatch(updateComponent({ component }));
          };

          $scope.onNChange = ({ n }) => {
            ngrxStoreService.dispatch(updateComponent({ component: { n } }));
          };

          $scope.onPartitionedFieldsChange = (value) => {
            $scope.component.partitioned_fields = value;
          };

          $scope.onPartitionedFieldsValidityChange = (value) => {
            $scope.groupByValidity = value;
          };

          $scope.onSortCollectionValidityChange = (value) => {
            $scope.sortValidity = value;
          };

          $scope.onOrderedFieldsChange = (value) => {
            $scope.component.ordered_fields = value;
          };

          $scope.$watchGroup(
            ['sortValidity', 'groupByValidity', 'component.partitioning', 'component.order', 'component.n'],
            function () {
              // if 'partition_by' is selected, then group by fields must be valid. if not 'partition_by' then just be valid. same for sort
              const valid =
                !($scope.component.partitioning === 'partition_by' && !$scope.groupByValidity) &&
                !($scope.component.order === 'sort' && !$scope.sortValidity) &&
                $scope.component.n > 0;

              $scope.onValidityChange(valid);
            },
          );
        },
      ],
    };
  },
]);
